import { Select } from "../../components/select";
import { BSHorse } from "@/models/horse";
import { BSShowService } from "@/models/showService";

export const InlineHorseSelect = ({ 
  show, 
  horses, 
  onChange 
}: { 
  show: BSShowService, 
  horses: BSHorse[], 
  onChange: (horseId: string) => void 
}) => {
  return (
    <Select
      value={show.horseId}
      onChange={(e) => onChange(e.target.value)}
      className="min-w-[200px]"
    >
      <option value="">Select a horse...</option>
      {horses
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(horse => (
          <option key={horse.id} value={horse.id}>
            {horse.name}
          </option>
        ))}
    </Select>
  );
};